<template>
  <el-select
    id="GjwSelect"
    v-model="value"
    :class="config.class"
    :style="config.style || { width: '100%' }"
    :multiple="config.multiple"
    :value-key="config.valueKey"
    :clearable="config.clearable !== false"
    :disabled="config.disabled"
    :placeholder="config.placeholder || '请选择'"
    @change="(val)=>{valChange(val, config)}"
  >
    <el-option
      v-for="(opt, index) in config.options"
      :key="index"
      :label="opt[labelKey] ? opt[labelKey] : opt"
      :value="((opt[valueKey] || opt[valueKey]===false || opt[valueKey]===0) && !config.valueIsObject) ? opt[valueKey] : opt"
    />
  </el-select>
</template>

<script>
export default {
  name: 'GjwSelect',
  props: {
    config: Object,
    initValue: {
      type: [String, Object, Number, Array, Boolean],
      default: ''
    }
  },
  data() {
    return {
      value: this.initValue,
      // 直接使用this.config.labelKey会报错，所以这里转接下
      labelKey: this.config.labelKey || 'label',
      valueKey: this.config.valueKey || 'value',
    }
  },
  watch: {
    initValue: {
      handler(newVal) {
        this.value = newVal
      },
      immediate: true
    }
  },
  created() {
    if (this.config.optionsApi) {
      this.config.optionsApi(this.config.apiParams).then((data) => {
        this.config.options = data.list || data || []
      })
    }
  },
  methods: {
    valChange(val, item) {
      this.$emit('change', val, item)
    },
  }
}
</script>

<style scoped>

</style>
